import { getFlexPaneWidth } from 'owa-suite-header-store';

// Update the internal width of the flex pane based on the current state
export const updateFlexPaneInternalWidth = (): void => {
    document.documentElement.style.setProperty('--flexPaneWidth', `${getFlexPaneWidth()}px`);
};
